import { IState } from 'legacy/lut/store'

export const selectCompletenessState = (state: IState) => state.partner360.completeness
